<template>
  <div class="dashboard">
    <div class="dashboardSideBar">
      <div class="dashboardSideBarWrapper">
        <router-link tag="div" :to="{name: 'campaignhostrevenue'}" class="dashboardSideBarWrapper__adx-balance">
          <div class="dashboardSideBarWrapper__adx-balance__title">Host Balance:</div>
          <div class="dashboardSideBarWrapper__adx-balance__value">{{totalBalance | formatMoney}}</div>
        </router-link>
      </div>
      <sidebar-menu />
    </div>
    <div class="dashboard__main container-router">
      <router-view />
    </div>
  </div>
</template>

<script>
import SideBar from "@/components/SideBar/Desktop"

import { mapGetters } from 'vuex'
import api from '@/api'
import { apiV2 } from '@/api/urls'

export default {
  name: `adx-dashboard`,
  components: {
    'sidebar-menu': SideBar
  },
  data() {
    return {
      adxBalance: 15000000,
      totalBalance: 0,
    }
  },
  computed: {
    ...mapGetters ({
      finalBalance: 'finalBalance'
    }),
  },
  mounted() {
    (async () => {
      // await this.$store.dispatch(`getFinalBalance`)
      const {data} = await api.get(apiV2.campaignHostBalance, { needToken: true })
      this.totalBalance = data.host_balance || 0
    })();
  }
}
</script>

<style lang="scss">
@import "./index.scss";
</style>
